import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const AccessDenied = ({ onNavigateBack }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const handleGoBack = () => {
    navigate('/dashboard');
  };

  return (
    <div className="container-fluid mt-5">
      <div className="row justify-content-center">
        <div className="col-md-8 col-lg-6">
          <div className="text-center">
            <div style={{ marginBottom: '30px' }}>
              <i
                className="las la-lock-open"
                style={{ fontSize: '80px', color: '#dc3545' }}
              ></i>
            </div>

            <h1 style={{ fontSize: '48px', fontWeight: 'bold', marginBottom: '10px' }}>
              Access Denied
            </h1>

            <p style={{ fontSize: '16px', color: '#666', marginBottom: '20px' }}>
              You do not have permission to access this page.
            </p>

            <div
              style={{
                backgroundColor: '#f8f9fa',
                padding: '15px 20px',
                borderRadius: '6px',
                marginBottom: '30px',
                borderLeft: '4px solid #dc3545',
              }}
            >
              <p style={{ margin: 0, color: '#555', fontSize: '14px' }}>
                <strong>Requested URL:</strong> <code>{location.pathname}</code>
              </p>
              <p style={{ margin: '10px 0 0 0', color: '#666', fontSize: '13px' }}>
                Contact your administrator if you believe you should have access to this page.
              </p>
            </div>

            <button
              onClick={handleGoBack}
              className="btn btn-primary"
              style={{
                padding: '10px 30px',
                fontSize: '16px',
                borderRadius: '6px',
              }}
            >
              <i className="fa fa-arrow-left me-2"></i>
              Go to Dashboard
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccessDenied;
